import type { PassType, Duration, DurationMeasure } from '@/types';
import type { CreatePassTypeRequest, UpdatePassTypeRequest } from '@/shared/api';

const durationToWire = (duration: PassType['duration']): CreatePassTypeRequest['duration'] => {
  if (duration === null) return null;
  return { measure: duration.measure, number: duration.number };
};

export const templateDraftToCreateRequest = (
  draft: Omit<PassType, 'id'>
): CreatePassTypeRequest => ({
  name: draft.name,
  credits: draft.credits,
  duration: durationToWire(draft.duration),
});

export const templateDraftToUpdateRequest = (
  draft: Omit<PassType, 'id'>
): UpdatePassTypeRequest => ({
  name: draft.name,
  credits: draft.credits,
  duration: durationToWire(draft.duration),
});

export const buildPassTypeFromCreate = (
  id: string,
  variables: CreatePassTypeRequest
): PassType => ({
  id,
  name: variables.name,
  credits: variables.credits,
  duration:
    variables.duration === null
      ? null
      : {
          measure: variables.duration.measure as DurationMeasure,
          number: variables.duration.number,
        },
});

export type { Duration };
